import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateContractRequest, UpdateContractRequest, Contract, PagedContractsRequest, PagedContractsResponse } from '../../core/models/contract.model';

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  createContract(contractData: CreateContractRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/contracts/create`, contractData);
  }

  getAllContracts(): Observable<any> {
    return this.http.get(`${this.apiUrl}/contracts/get-all`).pipe(
      map((response: any) => response)
    );
  }

  getContractById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/contracts/${id}`);
  }

  updateContract(id: string, contractData: UpdateContractRequest): Observable<any> {
    return this.http.put(`${this.apiUrl}/contracts/${id}`, contractData);
  }

  getPagedContracts(request: PagedContractsRequest): Observable<PagedContractsResponse> {
    return this.http.post<PagedContractsResponse>(`${this.apiUrl}/contracts/paged`, request);
  }

  getContractsByCustomerId(customerId: string): Observable<Contract[]> {
    return this.http.get<Contract[]>(`${this.apiUrl}/contracts/customer/${customerId}`);
  }

  checkReservationHasContract(reservationId: string): Observable<{success: boolean, hasContract: boolean}> {
    return this.http.get<{success: boolean, hasContract: boolean}>(`${this.apiUrl}/contracts/reservation/${reservationId}/has-contract`);
  }
}
